@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information
        (tagInformationUpdated)="updateTaggingDetails($event)"
        [line]="entityLine()"
        [isOem]="isOem()"
        [tags]="taggingDetails()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"
        (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()"
        [selectionEntities]="selectionEntities()"></app-unit-information>
      <app-enviro-kit-site-survey
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-enviro-kit-site-survey>
      <app-system-inputs
        (valueChanged)="validateAndRateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"
        (unitTypeChanged)="unitTypeChanged()"
        (systemTypeChanged)="systemTypeChanged()"></app-system-inputs>
      <span class="caveat-label">Note: This EnviroKIT solution does not include the Return Air Blockoff Panel.</span>
      <app-indoor-air-quality
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-indoor-air-quality>
      <app-direct-drive-performance-input
        (valueChanged)="validateAndRateUnit()"
        [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        (inputUnitsChanged)="inputUnitsChanged()"
        [ratingResponse]="unitRatingResponse()"></app-direct-drive-performance-input>
      <app-direct-drive-performance-results [selectionEntities]="selectionEntities()" [ratingResponse]="unitRatingResponse()"></app-direct-drive-performance-results>
      <app-enviro-kit-mechanical-options
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-enviro-kit-mechanical-options>
      <app-enviro-kit-controls
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-enviro-kit-controls>
      <app-enviro-kit-coil-options
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-enviro-kit-coil-options>
      <app-enviro-kit-primary-valve-package
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-enviro-kit-primary-valve-package>
      <app-enviro-kit-secondary-valve-package
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-enviro-kit-secondary-valve-package>
      <app-enviro-kit-standard-features
        (valueChanged)="validateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"></app-enviro-kit-standard-features>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices
      [modelImagePath]="unitImagePath()"
      [messages]="messages()"
      [skus]="skus()"
      [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()"
      (sfrFlagChanged)="sfrFlagChanged()"></app-skus-and-prices>
  </div>
</div>
